import Stack from '@mui/material/Stack';
import { QuickSearchLightboxItemSkeleton } from './QuickSearchLightboxItemSkeleton';

export const QuickSearchLightboxLoader = () => {
  return (
    <Stack direction="column">
      <QuickSearchLightboxItemSkeleton />
      <QuickSearchLightboxItemSkeleton />
      <QuickSearchLightboxItemSkeleton />
      <QuickSearchLightboxItemSkeleton />
      <QuickSearchLightboxItemSkeleton />
      <QuickSearchLightboxItemSkeleton />
    </Stack>
  );
};
